import { createSlice } from '@reduxjs/toolkit';

import type {
  SecretariaMember,
  SecretariaPermissionGroup,
} from '../../types/secretariaPermissions';
import {
  fetchSecretariaMemberPermissions,
  fetchSecretariaPermissionsPanel,
  removeSecretariaMember,
  saveSecretariaMemberPermissions,
} from './actions';

interface SecretariaPermissionsState {
  groups: SecretariaPermissionGroup[];
  members: SecretariaMember[];
  loading: boolean;
  error: string | null;
}

const initialState: SecretariaPermissionsState = {
  groups: [],
  members: [],
  loading: false,
  error: null,
};

const atualizarPermissoes = (
  state: SecretariaPermissionsState,
  memberId: string,
  permissions: string[],
) => {
  state.members = state.members.map((member) =>
    member.id === memberId ? { ...member, permissions } : member,
  );
};

const secretariaPermissionsSlice = createSlice({
  name: 'secretariaPermissions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSecretariaPermissionsPanel.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSecretariaPermissionsPanel.fulfilled, (state, action) => {
        state.loading = false;
        state.groups = action.payload.groups;
        state.members = action.payload.members;
      })
      .addCase(fetchSecretariaPermissionsPanel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Erro ao carregar usuários e permissões';
      })
      .addCase(fetchSecretariaMemberPermissions.fulfilled, (state, action) => {
        atualizarPermissoes(state, action.payload.memberId, action.payload.permissions);
      })
      .addCase(saveSecretariaMemberPermissions.fulfilled, (state, action) => {
        atualizarPermissoes(state, action.payload.memberId, action.payload.permissions);
      })
      .addCase(removeSecretariaMember.fulfilled, (state, action) => {
        state.members = state.members.filter((member) => member.id !== action.payload);
      });
  },
});

export const secretariaPermissionsReducer = secretariaPermissionsSlice.reducer;
